export default __webpack_public_path__ + "static/media/liwatlogo.2198d931.svg";